import type {
  ModelTask,
  ObjectiveDataModality,
  ObjectiveDataOnHand,
  ObjectiveDeployTarget,
  ObjectiveSupport,
  PlanStepState,
} from '@ddp/shared';

import type { MessageKey } from '../../i18n/index.js';

/**
 * Correspondances code → clé i18n pour l'objectif et son plan (ADR-0028). Centralisées ici pour que
 * le panneau (détail projet) et la section Objectifs (page Model) parlent le même langage.
 */

export const TASK_LABEL: Record<ModelTask, MessageKey> = {
  DETECTION: 'objective.task.DETECTION',
  TRACKING: 'objective.task.TRACKING',
  TERRAIN: 'objective.task.TERRAIN',
  TRAJECTORY: 'objective.task.TRAJECTORY',
};

export const MODALITY_LABEL: Record<ObjectiveDataModality, MessageKey> = {
  OPTICAL: 'objective.modality.OPTICAL',
  INFRARED: 'objective.modality.INFRARED',
  ACOUSTIC: 'objective.modality.ACOUSTIC',
  RADAR: 'objective.modality.RADAR',
  TELEMETRY: 'objective.modality.TELEMETRY',
};

export const SUPPORT_LABEL: Record<ObjectiveSupport, MessageKey> = {
  IMAGE: 'objective.support.IMAGE',
  VIDEO_STREAM: 'objective.support.VIDEO_STREAM',
  TIME_SERIES: 'objective.support.TIME_SERIES',
};

export const DEPLOY_LABEL: Record<ObjectiveDeployTarget, MessageKey> = {
  DRONE: 'objective.deploy.DRONE',
  UGV: 'objective.deploy.UGV',
  GROUND: 'objective.deploy.GROUND',
};

export const DATA_ON_HAND_LABEL: Record<ObjectiveDataOnHand, MessageKey> = {
  NONE: 'objective.dataOnHand.NONE',
  VIDEOS: 'objective.dataOnHand.VIDEOS',
  LOGS: 'objective.dataOnHand.LOGS',
};

export const STEP_LABEL: Record<string, MessageKey> = {
  dataset: 'objective.step.dataset',
  'base-model': 'objective.step.baseModel',
  train: 'objective.step.train',
  evaluate: 'objective.step.evaluate',
  deploy: 'objective.step.deploy',
  analyze: 'objective.step.analyze',
  'coming-soon': 'objective.step.comingSoon',
};

export const BRANCH_LABEL: Record<string, MessageKey> = {
  annotate: 'objective.branch.annotate',
  reuse: 'objective.branch.reuse',
  clean: 'objective.branch.clean',
  simulate: 'objective.branch.simulate',
  field: 'objective.branch.field',
  adopt: 'objective.branch.adopt',
  import: 'objective.branch.import',
};

export const STATE_LABEL: Record<PlanStepState, MessageKey> = {
  done: 'workflow.state.done',
  current: 'workflow.state.current',
  todo: 'workflow.state.todo',
  locked: 'workflow.state.locked',
};
